import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage} from 'react-intl';

import {IStore} from 'redux/interface';
import {dialogueAsyncActions, startXpedition, getTranslations, restartXpedition} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';
import {ReactComponent as XpeditionIcon} from 'assets/image/menu-auth/xpedition.svg';
import {getLocalizedTitle} from 'components/header/utils';

import './styles.scss';
import {useNavigate, useParams} from 'react-router-dom';
import {BotMode} from '@wholesalechange/chatcomponent';

export const XpeditionChat: React.FunctionComponent = () => {
  const {
    dialogue
  } = useSelector((state: IStore) => state.dialogue);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);
  const {
    locale
  } = useSelector((state: IStore) => state.translation);
  const dispatch = useDispatch();
  const [dialogueId, setDialogueId] = useState<number>();
  const {xpeditionId, restart} = useParams();
  const history = useNavigate();

  useEffect(() => {
    dispatch(closeArticle());
  }, []);

  useEffect(() => {
    if (dialogue) {
      setDialogueId(dialogue.id);
    }
  }, [dialogue]);

  useEffect(() => {
    if (xpeditionId) {
      if (restart === 'restart') {
        dispatch(dialogueAsyncActions[restartXpedition](Number(xpeditionId)));
        history(`/xpedition/${xpeditionId}`, {replace: true});
      } else {
        dispatch(dialogueAsyncActions[startXpedition](Number(xpeditionId)));
      }
    }
  }, [xpeditionId]);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return page?.translationKey || TranslationKeys.Chat;
  }, [settings]);

  const title = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return page?.title || Pages.Xpedition;
  }, [settings]);

  const localizedTitle = useMemo(() => {
    const page = settings?.pages.find((p) => p.name.toLowerCase() === Pages.Xpedition.toLowerCase());

    return getLocalizedTitle(page?.title, page?.titles, locale);
  }, [settings, locale]);

  useGetTranslations({translationKey});

  return <div className="xpedition">
    {
      !loading.includes(getTranslations) && <>
        <h1 className="xpedition__title">
          {/* <XpeditionIcon className="xpedition__icon"/>*/}
          {localizedTitle || (
            <FormattedMessage
              id={`gritx.common.navigation.${title}`}
              defaultMessage={title}
            />
          )} {dialogue && <span className="xpedition__title-dialogue-name"> - {dialogue.name}</span>}
        </h1>
        <BotChat chatType={BotType.Xpedition} chatMode={BotMode.NoHistory} dialogueId={dialogueId}
          title={dialogue?.name || ''}
          tabsEnabled={settings?.chatSettings?.tabsEnabled || false}/>
      </>
    }
  </div>;
};
